div.file-row.odd{background:#cce5ff}div.file-row{padding:10px 0}div.file-row button{margin-left:5px}.progress{background:none;border:1px #ccc solid}.percentTag{text-align:right!important;color:#000;align-items:center}
/*# sourceMappingURL=file-upload.component-QUYZDKCQ.css.map */
